import { formatCurrency } from '../../../utils/formatters';
import { PropertyBadgeItem } from './propertyCardBadgeTypes';
import { normalizePropertyTags, getTagCardBadgeColor } from '../../../utils/propertyTagUtils';

const DAVIVIENDA_BADGE_IMAGE =
  'https://storage.googleapis.com/portal-brokers-ciencuadras.firebasestorage.app/ayuda%20sismo/Etiqueta%20davivienda.png';

export interface BuildPropertyBadgesParams {
  hasDaviviendaCreditPromo?: boolean;
  tiene_oferta?: boolean;
  valor_oferta?: number | null;
  es_preventa?: boolean;
  hasCommissionOverride?: boolean;
  isNewlyAdded?: boolean;
  isClientRole?: boolean;
  tags?: string[] | null;
  tag?: string[] | null;
}

export const buildPropertyBadgesList = (params: BuildPropertyBadgesParams): PropertyBadgeItem[] => {
  const {
    hasDaviviendaCreditPromo,
    tiene_oferta,
    valor_oferta,
    es_preventa,
    hasCommissionOverride,
    isNewlyAdded,
    isClientRole,
    tags,
    tag,
  } = params;

  const list: PropertyBadgeItem[] = [];

  if (isClientRole && hasDaviviendaCreditPromo) {
    list.push({
      id: 'davivienda-credit',
      imageUrl: DAVIVIENDA_BADGE_IMAGE,
      imageAlt: 'Crédito Davivienda 8%',
      title: 'Crédito Davivienda 8%',
    });
  }

  if (tiene_oferta) {
    list.push({
      id: 'oferta-presentada',
      label: '📩 Propiedad con oferta presentada',
      bgClass: 'bg-emerald-600',
      borderClass: 'border-2 border-white',
      textClass: 'text-white',
      title: valor_oferta ? `Valor de la oferta: ${formatCurrency(valor_oferta)}` : undefined,
    });
  }

  if (es_preventa) {
    list.push({
      id: 'preventa',
      label: '🚀 PREVENTA EXCLUSIVA',
      bgClass: 'bg-[#4338ca]',
      borderClass: 'border-2 border-yellow-400',
      textClass: 'text-white',
    });
  }

  if (hasCommissionOverride) {
    list.push({
      id: 'comision-especial',
      label: '💰 COMISIÓN ESPECIAL',
      bgClass: 'bg-[#facc15]',
      borderClass: 'border-2 border-white',
      textClass: 'text-black',
    });
  }

  if (isNewlyAdded && !es_preventa) {
    list.push({
      id: 'recien-agregado',
      label: '✨ Recién Agregado',
      bgClass: 'bg-blue-600',
      borderClass: 'border-2 border-white',
      textClass: 'text-white',
    });
  }

  // Tags del inmueble como badges visuales sobre la imagen (igual que recién agregado)
  const cleanTags = normalizePropertyTags(tag, tags);
  cleanTags.forEach((t, idx) => {
    list.push({
      id: `prop-tag-${t.toLowerCase().replace(/[^a-z0-9]/g, '-')}-${idx}`,
      label: `🏷️ ${t.toUpperCase()}`,
      bgClass: getTagCardBadgeColor(t, idx),
      borderClass: 'border-2 border-white',
      textClass: 'text-white',
      title: `Tag: ${t}`,
    });
  });

  return list;
};
